export default "__VITE_ASSET__DzGwqvMd__"